export abstract class ValidationMessageProvider<T> {
  abstract getMessage(obj: T, path: string, code: string): string;
}
